import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import './TeamEstimateDecider.css';

export default class extends Component {
  render() {
    if (this.props.editing) {
      return (
        <div className="team-estimate-decider">
          <div className="options">
            <div className="option" onClick={this.props.onToggleEditing}>
              <MaterialIcon icon="check" />
              <div className="option-text">Done</div>
            </div>
          </div>
        </div>
      );
    } else {
      let nextOrFinishOption = (this.props.roomStepsReady) ? (
        <div className="option" onClick={this.props.onRoomNextStep}>
          <MaterialIcon icon="flag" />
          <div className="option-text">Finish</div>
        </div>
      ) : (
        <div className="option" onClick={this.props.onRoomNextStep}>
          <MaterialIcon icon="arrow_forward" />
          <div className="option-text">Next</div>
        </div>
      );

      return (
        <div className="team-estimate-decider">
          <div className="options">
            <div className="option" onClick={this.props.onToggleEditing}>
              <MaterialIcon icon="edit" />
              <div className="option-text">Edit</div>
            </div>
            <div className="option" onClick={this.props.onRoomEstimatesReset}>
              <MaterialIcon icon="refresh" />
              <div className="option-text">Revote</div>
            </div>
            {nextOrFinishOption}
          </div>
        </div>
      );
    }
  }
}

// Options
  // Edit
  // Rethrow
  // Next
  // Finish



// WEBPACK FOOTER //
// ./src/Room/TeamEstimateDecider.js